export const getCurrentFrame = (animation: any) => {
  if (!animation) return 0;
  const targetedAnimations = animation.targetedAnimations;
  if (!targetedAnimations.length) return 0;
  const runtimeAnimations = animation.targetedAnimations[0].animation.runtimeAnimations;
  if (!runtimeAnimations.length) return 0;
  return runtimeAnimations[0].currentFrame;
};
export const getTimeFromInteger = (input: number): string => {
  let hours = Math.floor(input / 3600);
  let minutes = Math.floor((input - hours * 3600) / 60);
  let seconds = input - hours * 3600 - minutes * 60;
  if (minutes < 10) {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'string' is not assignable to type 'number'.
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    // @ts-expect-error todo(ts-migration) TS2322 Type 'string' is not assignable to type 'number'.
    seconds = `0${seconds}`;
  }
  return `${minutes}:${seconds}`;
};